export const storeDelay = 5e2;

export const selector = 'data-sapo-widget';

export const components = ['avatars', 'drop-down', 'graph-bars', 'graph-circle', 'graph-compare', 'graph-lines', 'icon', 'message', 'modal', 'news'];

export const scrollable = 'data-sapo-widget-prevent-scroll';

export const cacheLimit = 50;

export default {
    storeDelay,
    selector,
    components,
    scrollable,
    cacheLimit
}